import { middleofficeRequest } from '../axios'
import useAuthExtranet from './useAuthExtranet'
const useRefreshToken = () => {
  const { auth, setAuth } = useAuthExtranet()

  const refresh = async () => {
    try {
      const response = await middleofficeRequest.get(
        'middleoffice/auth/refresh',
        {
          headers: {
            Authorization: `Bearer ${auth.refreshToken}`,
          },
        }
      )
      setAuth((prev) => {
        return {
          ...prev,
          accessToken: response.data.accessToken,
          refreshToken: response.data.refreshToken,
        }
      })
      return response.data.accessToken
    } catch (error) {
      setAuth({})
    }
  }
  return refresh
}

export default useRefreshToken
